import type { IconSvgObject } from './types';

const ArrowReloadVerticalIcon: IconSvgObject = [
  ["path", { d: "M5.5 3.5L5.5 14.5C5.5 18.2133 8.18503 21 12 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.5 20.5L18.5 9.5C18.5 5.78672 15.815 3 12 3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21 18C21 18 19.1588 20.5 18.5 20.5C17.8412 20.5 16 18 16 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M8 5.50022C8 5.50022 6.15878 3.00025 5.49998 3.00024C4.84118 3.00024 3 5.50024 3 5.50024", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default ArrowReloadVerticalIcon;
